module.exports = __webpack_public_path__ + "img/ExclusiveGateway.e835fc41.svg";